module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/90/assets/images/ab64515aac96f860a1d7eb690d9402d9.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Gold/Gold4.svg
// module id = C4aY
// module chunks = 1